import React from 'react';

const Marketplaces = () => {
    return (
            <section
                className="section section-lg section-lead section-bold section-theme-autoheight section-theme-darken section-eyebrow-include section-theme-indent-bottom-inside-md section-theme-indent-bottom-inside-lg-option section-theme-indent-no-bottom-outside  section-43 section-i2">
                <div className="container">
                    <div className="row">
                        <div
                            className="section-content-wrapper col-lg-8 col-lg-offset-2 col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1 col-xs-12">
                            <div className="section-content">
                                <div className="section-content-caption"><p className="section-eyebrow">Trade your
                                    NFT</p><h2>Marketplaces at your disposal.</h2>
                                    <p>You can immediately place your bears on the marketplaces for resale. A number of
                                        popular and new marketplaces are available to you that support Binance Smart
                                        Chain.</p></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section-option container">
                    <div className="strip-wrapper row">
                        <div
                            className="col-lg-12 col-lg-offset-0 col-md-8 col-md-offset-2  col-sm-10 col-sm-offset-1 col-xs-12">
                            <div className="strip-items strip-center">
                                <div className="strip strip-sm">
                                    <figure className="strip-icon icon icon-lootex"></figure>
                                    <div className="strip-caption"><h3 className="h5">lootex.io</h3>
                                        <p>A new marketplace that is gaining popularity thanks to its cross-chain and
                                            intuitive interface.</p>
                                        <p><a href="https://lootex.io/stores/cyberbearz" className="link"
                                              target="_blank">Trade here</a></p></div>
                                </div>
                                <div className="strip strip-sm">
                                    <figure className="strip-icon icon icon-nftkey"></figure>
                                    <div className="strip-caption"><h3 className="h5">nftkey.app</h3>
                                        <p>Reliable marketplace with selected collections and the ability to sort NFT by
                                            rarity and price.</p>
                                        <p><a href="https://nftkey.app/collections/cyberbearz/" className="link"
                                              target="_blank">Trade here</a></p></div>
                                </div>
                                <div className="strip strip-sm">
                                    <figure className="strip-icon icon icon-scv"></figure>
                                    <div className="strip-caption"><h3 className="h5">scv.finance</h3>
                                        <p>A young trading platform, but already established in the BSC environment.
                                            Sells about 12,800 NFT per month!</p>
                                        <p><a href="https://scv.finance/nft/collection/cyberbearz" className="link"
                                              target="_blank">Trade here</a></p></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </section>
    );
};

export default Marketplaces;